import { SetStateAction } from "react";
import { colors } from "../../../data/colors";
import { stdObject } from "../../../data/types/stdObject";
import { toPrice } from "../../../utils/toPrice";
import { createCommissionMsg } from "../functions/commissions/createCommissionMsg";

export const approveCommModal = ({
  t,
  customUpdate,
  windowValues,
  setMsg,
  setWindowValues,
  closeMsg,
  logoutAction,
}: stdObject) => {
  return {
    title: t("p.askApproveCommission"),
    label: `${windowValues.data?.name} - ${toPrice(windowValues.data?.total)}`,
    inputs: [
      {
        value: windowValues.date ?? "",
        type: "datetime-local",
        onChange: (o: { target: { value: SetStateAction<string> } }) =>
          setWindowValues({ ...windowValues, date: o.target.value }),
      },
    ],
    buttons: [
      {
        label: t("p.approve"),
        onClick: () => {
          createCommissionMsg({
            windowValues,
            customUpdate,
            setMsg,
            setWindowValues,
            logoutAction,
            closeMsg,
          });
        },
        color: colors.green,
      },
      {
        label: t("p.cancel"),
        onClick: closeMsg,
        color: colors.darkGrey,
      },
    ],
  };
};
